import { createPresenceClient } from "../shared/presence-client.js";
import { mountStrip } from "../shared/strip.js";
import { mountProse } from "../prose.js";

const SECTIONS = [
  { roman: "I",   title: "TWO SPACES, TWO TIMES",            after: 1 },
  { roman: "II",  title: "THREE COORDINATES",                after: 2 },
  { roman: "III", title: "A VOCABULARY, OPENLY CONTESTABLE", after: 4 },
  { roman: "IV",  title: "PLAYING AS METHOD",                after: 6 },
];

window.addEventListener("load", () => {
  const presence = createPresenceClient();
  mountStrip(presence);
  presence.connect();

  const article = document.querySelector("article.concept");
  if (article) {
    mountProse(article, { numbered: true, sections: SECTIONS });
  }

  // Display title fade-in / track-open after a small delay
  setTimeout(() => {
    document.querySelector(".prose-display")?.classList.add("ready");
  }, 80);
});
